function addBreadcrumbSchema() {
    const head = document.querySelector('head');
    const breadcrumb = document.querySelectorAll('nav.breadcrumb > a');
    const script = document.createElement('script');
    script.setAttribute('type', 'application/ld+json')
    script.setAttribute('id', 'breadcrumb-markup')
    
    const schema = {
        '@context': "https://schema.org",
        '@type': "BreadcrumbList",
        'itemListElement': []
    };

    for (i = 0; i < breadcrumb.length; i++) {
        schema.itemListElement.push({
            "@type": "ListItem",
            "position": i + 1,
            "name": breadcrumb[i].title,
            "item": breadcrumb[i].href
        })
    }

    script.innerHTML = JSON.stringify(schema);
    head.appendChild(script);
}
addBreadcrumbSchema();
